
import BaseService from '../baseService'
import base_http from "../../../utils/http/http"

class HttpService extends BaseService {

	constructor() {
		super("com.jacada.common.HttpService");

		this.http = base_http;
	}

	getHttp() {
		return this.http;
	}

	setHttp(_http) {
		this.http = _http;
	}

	execute(options) {
		return this.http(options);
	}
}

export default new HttpService();






// WEBPACK FOOTER //
// ../common/services/src/http/httpService.js